import { Env } from '@shopee-user/global';

const FIREBASE_CONFIG =
  __ENV__ === Env.Live
    ? {
        apiKey: 'AIzaSyD79X37epOXaOgRcY7yX9Qpf4HMYnPuGgU',
        projectId: 'tob-web',
        appId: '1:994065083274:web:78b8aa543c9d50f114b673',
      }
    : {
        apiKey: 'AIzaSyD79X37epOXaOgRcY7yX9Qpf4HMYnPuGgU',
        projectId: 'tob-web',
        appId: '1:994065083274:web:6a1f84df40d4693714b673',
      };

export default FIREBASE_CONFIG;
